module.exports = __webpack_public_path__ + "img/home_2.84db834e.png";